module.exports = __webpack_public_path__ + "static/media/humanoid-corncob.c7c679c4.png";